const HISTORY_SUPPORT = !!(history && history.pushState);

const contestoverlay = document.querySelector('.js-contestoverlay');

const SelectedCompetitorImage = contestoverlay.querySelector('.js-competitor-image');
const SelectedCompetitorTitle = contestoverlay.querySelector('.js-competitor-title');
const SelectedCompetitorName = contestoverlay.querySelector('.js-competitor-name');
const SelectedCompetitorVotingCount = contestoverlay.querySelector('.js-competitor-voting-count');
const SelectedCompetitorVotingUrl = contestoverlay.querySelector('.js-competitor-voting-url');
const shareLinkItems = contestoverlay.querySelector('.dropdownShare__list').querySelectorAll('a');
const overlayBackdrop = document.querySelector('#contestoverlay-backdrop');

const contestOverlayCloseButton = document.querySelector('.js-competitor-close');
const voteButton = document.querySelector('.js-competitor-voting-url');

const cards = document.querySelectorAll('.card--competition');

let openedCompetitor = null;
let currBodyScrollPos = window.pageYOffset;

// check has voted
const myVote = getVotedCookie();
if (myVote) {
  const myVoteElement = document.querySelector(`#${myVote}`);
  if (myVoteElement) {
    document.body.classList.add('has-voted');
    const voteEL = myVoteElement.querySelector('.btn--vote');
    if (voteEL) {
      voteEL.classList.add('btn--voted');
    }
  }
}

// sorting random
const list = document.querySelector('#photlist');
if (list.getAttribute('data-sorting') === 'random') {
  for (let i = list.children.length; i >= 0; i--) {
    list.appendChild(list.children[Math.random() * i | 0]);
  }
  list.classList.add('show');
} else {
  list.classList.add('show');
}

contestOverlayCloseButton.addEventListener('click', (e) => {
  e.preventDefault();
  closeCompetitor();
});

overlayBackdrop.addEventListener('click', (e) => {
  e.preventDefault();
  closeCompetitor();
});

function vote(el, button) {
  if (myVote) {
    return;
  }
  const ajaxUrl = el.getAttribute('data-voting-url');
  button.setAttribute('disabled', true);
  document.body.classList.add('is-loading');
  fetch(ajaxUrl)
    .then((response) => response.json())
    .then((json) => {
      document.body.classList.remove('is-loading');
      if (json && json.voted) {
        setVotedCookie(el.getAttribute('id'));
        document.body.classList.add('has-voted');

        button.classList.add('btn--voted');
        const card = el.closest('[data-voting-count]');
        card.setAttribute('data-voting-count', json.votingCount);
        el.querySelector('span').innerHTML = json.votingCount;

        button.setAttribute('disabled', false);
        updateOverlayData(el);
      }
    }).catch((error) => {
      document.body.classList.remove('is-loading');
      el.setAttribute('disabled', false);
      console.warn(error);
    });
}

voteButton.addEventListener('click', (e) => {
  e.preventDefault();
  e.stopPropagation();
  vote(openedCompetitor, e.target);
});

function imageloaded(e) {
  const image = e.target;
  setTimeout(() => {
    image.classList.add('show');
  }, 10);
}

function updateOverlayData(el) {
  SelectedCompetitorImage.setAttribute('src', el.getAttribute('data-image'));
  SelectedCompetitorImage.addEventListener('load', imageloaded);

  SelectedCompetitorTitle.innerHTML = el.getAttribute('data-title');
  SelectedCompetitorName.innerHTML = el.getAttribute('data-name');
  SelectedCompetitorVotingCount.innerHTML = el.getAttribute('data-voting-count');
  SelectedCompetitorVotingUrl.setAttribute('data-voting-url', el.getAttribute('data-voting-url'));

  if (el.querySelector('.btn--voted')) {
    SelectedCompetitorVotingUrl.classList.add('btn--voted');
  } else {
    SelectedCompetitorVotingUrl.classList.remove('btn--voted');
  }

  const ancher = el.getAttribute('id');
  shareLinkItems.forEach((el) => {
    const href = el.getAttribute('href').split('#');
    el.setAttribute('href', `${href[0]}#${ancher}`);
  });
}

function openCompetitor(el) {
  contestoverlay.classList.add('open');

  updateOverlayData(el);
  openedCompetitor = el;

  stopScrollBody();

  const ancher = el.getAttribute('id');
  if (HISTORY_SUPPORT) {
    const str = window.location.href;
    const href = str.split('#');
    history.pushState({}, '', `${href[0]}#${ancher}`);
  }
}

function closeCompetitor(el) {
  openedCompetitor = null;

  contestoverlay.classList.remove('open');
  SelectedCompetitorImage.classList.remove('show');

  allowScrollBody();

  if (HISTORY_SUPPORT) {
    const str = window.location.href;
    const href = str.split('#');
    history.pushState({}, '', `${href[0]}`);
  }
}

function allowScrollBody() {
  document.body.classList.remove('no-scroll');
  document.body.style.top = '';
  window.scrollTo({ top: currBodyScrollPos, left: 0, behavior: 'instant' });
}

function stopScrollBody() {
  currBodyScrollPos = window.pageYOffset;
  document.body.style.top = `${-currBodyScrollPos}px`;
  document.body.classList.add('no-scroll');
}

cards.forEach((element) => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
    openCompetitor(element);
  });
});

window.addEventListener('load', () => {
  if (window.location.hash == '') {
    return false;
  }

  const el = document.querySelector(window.location.hash);

  if (el !== null && el.classList.contains('card--competition')) {
    openCompetitor(el);
  }
}, false);

// cookie
function setVotedCookie(value) {
  let expires = '';
  const days = 60;
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  expires = `; expires=${date.toUTCString()}`;
  document.cookie = `${'vote' + '='}${value || ''}${expires}; path=/`;
}
function getVotedCookie() {
  const nameEQ = 'vote=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
